(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ApplicationService', ApplicationService)

    /** @ngInject */
    function ApplicationService(HttpService) {
        const ApplicationService = {
            get,
            getByParameters,
            getAll,
            getAllByPermissionGroup,
            generateRandomHash,
            post,
            put,
            deleteData,
            validateCallbackUrl
        }

        return ApplicationService;

        function get(applicationId) {
            return HttpService.get(`/applications/${applicationId}`);
        }

        function getByParameters(params) {
            return HttpService.get('/applications/by-parameters', {
                params
            });
        }

        function getAll() {
            return HttpService.get('/applications/by-parameters', {
                params: {}
            });
        }

        function getAllByPermissionGroup(permissionGroupId) {
            return HttpService.get(`/applications/permission-group/${permissionGroupId}`);
        }

        function generateRandomHash() {
            return HttpService.get(`/applications/generate-new-token/32`);
        }

        function post(application) {
            return HttpService.post('/applications', application);
        }

        function put(application) {
            return HttpService.put('/applications', application);
        }

        function deleteData(applicationId) {
            return HttpService.delete(`/applications/${applicationId}`);
        }

        function validateCallbackUrl(params) {
            return HttpService.get('/applications/is-valid-callback-url', {
                params
            });
        }
    }
}());